<template>
  <div>
      <!--div style="height: 130px;"></div-->
      <!--div class="footer" style="position: fixed;top: calc(100% - 130px);z-index: 100;overflow: hidden;"-->
      <div class="footer" style="top: calc(100% - 130px);z-index: 100;">
          <!-- ============= 公共组件footer部分 ============= -->
          <ul :class="key === 0 ? 'footer-ul':''"  v-for="(foot, key) in footer">
              <li v-for="fff in foot">
                <a :href="fff['url']">{{fff['name']}}</a>
              </li>
          </ul>
          <!--ul class="footer-ul">
              <li><a href="">联系我们</a></li>
              <li><a href="">产品列表</a></li>
              <li><a href="">选型表</a></li>
              <li><a href="">常见问题</a></li>
          </ul>

          <ul>
              <li><a href="">新闻中心</a></li>
              <li><a href="">公司新闻</a></li>
              <li><a href="">行业新闻</a></li>
              <li><a href="">媒体报道</a></li>
          </ul>

          <ul>
              <li><a href="">加入我们</a></li>
              <li><a href="">校园招聘</a></li>
              <li><a href="">社会招聘</a></li>
              <li><a href="">我们的价值观</a></li>
              <li><a href="">给我们留言</a></li>
          </ul>

          <ul>
              <li><a href="">业务分部</a></li>
              <li><a href="">子公司</a></li>
              <li><a href="">销售站点</a></li>
              <li><a href="">港澳台&海区</a></li>
          </ul>

          <ul>
              <li><a href="">关于我们</a></li>
              <li><a href="">企业文化</a></li>
              <li><a href="">核心价值</a></li>
              <li><a href="">经营理念</a></li>
              <li><a href="">专利设计</a></li>
          </ul-->

          <!--ul>
              <li>
                  <span class="wechat" style="margin-left: 10px">关注微信公众号</span>
                  <img src="../assets/images/login/weixin.png" style="display: block;width:134px;"/>
              </li>
          </ul-->

          <!--&lt;!&ndash; ============= 备案号 ============= &ndash;&gt;-->
          <!--<div class="filling">-->
              <!--<span style="margin-left: 20%">Copyright(c) 2018-2020 by SINOWEALTH Electronic Ltd. All rights reserved</span>-->
              <!--<span style="margin-left: 8%">粤ICP备10051210号</span>-->
              <!--<span style="margin-left: 8%">股票代码 : 300327</span>-->
          <!--</div>-->

          <!-- ============= 备案号 ============= -->
          <div class="filling">
              <ul style="height: 25px;width: 1300px;text-align: center;list-style-type:none;margin: 0 auto">
                <li style="width: 700px;float: left">Copyright(c) 2018-2020 by SINOWEALTH Electronic Ltd. All rights reserved</li>
                <li style="width: 250px;float: left"><a href='https://beian.miit.gov.cn/' target="_blank">沪ICP备18039907号-2</a></li>
                <li style="width: 250px;float: left">股票代码 : 300327</li>
              </ul>
          </div>
      </div>
    </div>
</template>
<script>
  export default {
    name: "footer",
    data() {
        return {
            footer: [], // 底部数据
        }
    },
    mounted: function () {
        this.getfooter(); // 获取菜单
     },
    methods: {
        getfooter () { // 获取菜单
                let vm = this;
                this.$axios({
                        method:'get',
                        url:'/api/pre/json_go/footer',
                    }).then((response) =>{          //这里使用了ES6的语法
                        this.footer = response.data;
                    }).catch((error) =>
                        console.log(error)       //请求失败返回的数据
                    )
        },
    }
  }
</script>
<style>
  .footer { width: 100%;height: 130px;background-color: #090909;position: relative;min-width: 1300px }
  .footer > ul { display: inline-block;color: #ffffff;list-style:none;vertical-align:top;line-height: 20px;margin-left: 5%;}
  .footer > ul > li > a { color: #ffffff;}
  .footer .footer-ul { margin-left: 20% }
  .footer .filling { position:absolute;background-color: #ffffff;bottom: 0;width: 100%}
</style>



// WEBPACK FOOTER //
// src/pages/footer.vue